export default "__VITE_ASSET__C9n83ptt__"